import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Accordion } from "@website/ui/accordion";
import { FC } from "react";
export type FaqType = {
  title: string;
  list: Array<{
    answer: string;
    question: string;
    id?: string | number;
  }>;
};
export const Faq: FC<FaqType> = t0 => {
  const $ = _c(10);
  const {
    title,
    list
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-on-surface-medium-emphasis size-5 overflow-hidden text-xl leading-5"><MaterialIcon name="help_outline" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <div className="mb-4 flex h-8 flex-row items-center gap-2">{t1}<h2 className="text-on-surface-high-emphasis lg:text-headline-6 text-base">{title}</h2></div>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== list) {
    t3 = list.map(_temp);
    $[3] = list;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div itemScope={true} className="flex flex-col space-y-4" itemType="https://schema.org/FAQPage">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <article className="w-full py-8">{t2}{t4}</article>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp(item, index) {
  return <Accordion content={item.answer} initialExpanded={index <= 3} key={item.question} title={item.question} />;
}